const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const ADMIN_AUTH_BASE = `${BACKEND_URL}/api/admin-auth`;

async function parseJsonSafely(response) {
  const contentType = response.headers.get("content-type") || "";
  if (!contentType.includes("application/json")) {
    return null;
  }
  return response.json();
}

export async function adminAuthFetch(url, options = {}) {
  return fetch(url, {
    ...options,
    credentials: "include",
    headers: {
      ...(options.headers || {}),
    },
  });
}

export async function getCurrentAdmin() {
  const response = await adminAuthFetch(`${ADMIN_AUTH_BASE}/me`);
  if (response.status === 401) {
    return null;
  }
  if (!response.ok) {
    const payload = await parseJsonSafely(response);
    const error = new Error(payload?.detail || "No se pudo validar la sesión");
    error.status = response.status;
    throw error;
  }
  return response.json();
}

export async function loginAdmin(email, password, otp = "") {
  const body = new URLSearchParams({
    username: email,
    password,
  });

  const response = await adminAuthFetch(`${ADMIN_AUTH_BASE}/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      ...(otp ? { "X-Admin-OTP": otp } : {}),
    },
    body,
  });

  if (!response.ok) {
    const payload = await parseJsonSafely(response);
    const error = new Error(payload?.detail || "Credenciales incorrectas");
    error.status = response.status;
    throw error;
  }

  return getCurrentAdmin();
}

export async function getAdminTwoFactorStatus() {
  const response = await adminAuthFetch(`${ADMIN_AUTH_BASE}/2fa/status`);
  if (response.status === 401) {
    return null;
  }
  if (!response.ok) {
    const payload = await parseJsonSafely(response);
    const error = new Error(payload?.detail || "No se pudo comprobar el estado del 2FA");
    error.status = response.status;
    throw error;
  }
  return response.json();
}

export async function setupAdminTwoFactor() {
  const response = await adminAuthFetch(`${ADMIN_AUTH_BASE}/2fa/setup`, {
    method: "POST",
  });
  if (!response.ok) {
    const payload = await parseJsonSafely(response);
    const error = new Error(payload?.detail || "No se pudo iniciar la configuracion de 2FA");
    error.status = response.status;
    throw error;
  }
  return response.json();
}

export async function enableAdminTwoFactor(code) {
  const response = await adminAuthFetch(`${ADMIN_AUTH_BASE}/2fa/enable`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ code }),
  });
  if (!response.ok) {
    const payload = await parseJsonSafely(response);
    const error = new Error(payload?.detail || "No se pudo activar el 2FA");
    error.status = response.status;
    throw error;
  }
  return response.json();
}

export async function disableAdminTwoFactor(code) {
  const response = await adminAuthFetch(`${ADMIN_AUTH_BASE}/2fa/disable`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ code }),
  });
  if (!response.ok) {
    const payload = await parseJsonSafely(response);
    const error = new Error(payload?.detail || "No se pudo desactivar el 2FA");
    error.status = response.status;
    throw error;
  }
  return response.json();
}

export async function logoutAdmin() {
  const response = await adminAuthFetch(`${ADMIN_AUTH_BASE}/logout`, {
    method: "POST",
  });

  if (!response.ok && response.status !== 401) {
    const payload = await parseJsonSafely(response);
    const error = new Error(payload?.detail || "No se pudo cerrar la sesión");
    error.status = response.status;
    throw error;
  }
}
